import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { RowComponent } from './RowComponent';
import { DraggableRow, DragHandle, RowWrapper } from './styled';
import { HolderOutlined } from '@ant-design/icons';

interface SortableRowProps {
  metricKey: string;
  data: any;
  dodData: any;
}

export const SortableRow = ({ metricKey, data, dodData }: SortableRowProps) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: metricKey,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <DraggableRow ref={setNodeRef} style={style} {...attributes}>
      <DragHandle {...listeners}>
        <HolderOutlined />
      </DragHandle>
      <RowWrapper>
        <RowComponent metricKey={metricKey} data={data} dodData={dodData} />
      </RowWrapper>
    </DraggableRow>
  );
};
